import { ReactElement } from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FileArchive } from 'lucide-react';

import { cn } from '@/helpers/shadCnUtils';

interface ImagesButtonProps {
  title: string;
  imageSource?: Array<string>;
  fontAwesomeIcon?: IconDefinition;
  hoverText: string;
  onClick: () => void;
  blankCount?: number;
}

const ImagesButton = ({
  title,
  imageSource,
  fontAwesomeIcon,
  hoverText,
  onClick,
  blankCount = 4,
}: ImagesButtonProps) => {
  return (
    <button
      onClick={onClick}
      title={hoverText}
      className={cn(
        'group hover:border-brandSecondary relative flex h-[54px] w-fit cursor-pointer items-center justify-center rounded-xl border-2 border-dashed border-gray-300 bg-white px-4 transition-all duration-200 hover:bg-gray-50 hover:shadow-sm',
      )}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex gap-2">
          {fontAwesomeIcon ? (
            <FontAwesomeIcon
              className="group-hover:text-brandSecondary w-8 text-2xl text-gray-600 transition-colors duration-200"
              icon={fontAwesomeIcon as IconProp}
            />
          ) : imageSource && imageSource.length ? (
            imageSource.map((source, index) => (
              <img
                key={index}
                src={source}
                alt={title}
                className="h-8 w-8 rounded-lg object-cover transition-transform duration-200 group-hover:scale-105"
              />
            ))
          ) : (
            Array.from({ length: blankCount }).map((_, index) => (
              <div
                key={index}
                className="h-8 w-8 rounded-lg bg-gray-200 transition-colors duration-200 group-hover:bg-gray-300"
              />
            ))
          )}
        </div>
      </div>
    </button>
  );
};

export default ImagesButton;
